import React, { createContext, useState, useEffect, useContext } from 'react';
import { getToken, removeToken, setToken } from '../service/auth';
import { Spinner } from 'reactstrap';
import api from '../service/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoading, setIstloading] = useState(true);
  const [user, setUser] = useState(null);
  const token = getToken();

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        if (token) {
          const response = await api.get('/auth/profile');
          const baseUser = response.data.user;
          setUser(baseUser);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error('Erro ao buscar perfil do usuário:', error);
        setUser(null);
      } finally {
        setIstloading(false);
      }
    };
    fetchUserProfile();
  }, [token]);

  const login = async (user, token) => {
    try {
      setUser(user);
      setToken(token);
    } catch (error) {
      console.error('Erro ao fazer login:', error);
    }
  };

  const logout = () => {
    removeToken();
    setUser(null);
  };

  if (isLoading) {
    return <div className='vh-100 d-flex align-items-center justify-content-center'><Spinner color='success' size={"sm"} /></div>;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
